import { render, staticRenderFns } from "./CatGallery.vue?vue&type=template&id=2c54556d&scoped=true"
import script from "./CatGallery.vue?vue&type=script&lang=js"
export * from "./CatGallery.vue?vue&type=script&lang=js"
import style0 from "./CatGallery.vue?vue&type=style&index=0&id=2c54556d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c54556d",
  null
  
)

export default component.exports